import axios from 'axios'
import { MONTHLY_COMMISSIONS_ENDPOINT } from '../../endpoints'

export async function postCreateNewMonthlyCommission(periodName, validity_from_date, validity_to_date, companyId) {
    const response = await axios.post(MONTHLY_COMMISSIONS_ENDPOINT, {period_name: periodName, validity_from_date, validity_to_date, companyId});
    return response
}